var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainPage"},[_c('Visual'),_c('News',{staticClass:"section"}),_c('Banner',{staticClass:"section"}),_c('House',{staticClass:"section"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }